// eslint-disable-next-line jsdoc/check-indentation
/**
 * Tento soubor je naplněn starou logikou ze SL, kterou se zpracovávjí entity workflow. Ať už z XML do objektu, či naopak.
 * Každá z níže popsaných funkcí musí mít komentář s popisem toho, proč je neoptimální.
 * Časem snad tento soubor bude obsahovat 0 funkcí. Musíme refaktorovat tyto kódy!
     * __                      __
  * .-'  `'.._...-----..._..-'`  '-.
 * /                                \
 * |  ,   ,'                '.   ,  |
  * \  '-/                    \-'  /
   * '._|          _           |_.'
      * |    /\   / \    /\    |
      * |    \/   | |    \/    |
       * \        \"/         /
        * '.    =='^'==     .'
          * `'------------'`
            * !REFAKTORUJ!
 */

import { Action, FormType, OpenForm, SendMail, SendMessageRecipientType, SendSMS, SendSmsRecipientType, SetAttribute, SetAttributeValueType } from "../workflowModel/Actions";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT, CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT, CONST_SEND_MAIL_DOCUMENT_CONDITION_AT, CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT, CONST_SEND_MAIL_FORMAT_AT, CONST_SEND_MAIL_RECIPIENT_AT, CONST_SEND_MAIL_RECIPIENT_TYPE_AT, CONST_SEND_MAIL_REPORT_TEMPLATE_AT, CONST_SEND_MAIL_SEND_POSTPONE_AT, CONST_SEND_MAIL_SUBJECT_AT, CONST_SEND_MAIL_SUMMARY_MAIL_AT, CONST_SEND_MAIL_TEXT_AT, CONST_SEND_SMS_RECIPIENT_AT, CONST_SEND_SMS_RECIPIENT_TYPE_AT, CONST_SEND_SMS_TEXT_AT, CONST_SET_ATTRIBUTE_ATTR_NAME_AT, CONST_SET_ATTRIBUTE_EL, CONST_SET_ATTRIBUTE_VALUE_EL, CONST_SET_ATTRIBUTE_VALUE_TYPE } from "./constants";
import { escapeXmlString, unescapeXmlString } from "./utils";

/**
 * Funkce se stará o zpracování XML elementu SetAttribute, který podle logiky v SL/Serveru, může reprezentovat 2 různé akce (SetAttribute nebo OpenForm).
 * Logika to není příliš šťastná a tak silně doporučuji refaktorovat na dva samotné typy. Momentálně je hlavní rozlišující faktor to, že pokud je hodnota attributu "attrName"
 * rovna "BLDialogFormName", tak se jedná o typ OpenForm. Jinak se jedná o SetAttribute. Rovněž se mi nelíbí použití omnipotent atributů,
 * které v sobě uchovávjí rozdílné hodnoty oddělené nějakým středníkem...
 *
 * @param actionEl XML pro aktivitu.
 * @param actions Pole akcí, které se má appendovat.
 */
export const manageSetAttributeXmlElement = (actionEl: Element, actions: Action[]) => {
    const attrname = actionEl.getAttribute(CONST_SET_ATTRIBUTE_ATTR_NAME_AT) ?? "";
    const value = unescapeXmlString(actionEl.children[0]?.innerHTML ?? "");

    if (attrname === "BLDialogFormName") { // další hloupá logika SL, snad se v budoucnu refaktoruje, aby OpenForm byla samotná akce se svým typem a xml atributem...
        const openFormularCollection = value.split(";");

        openFormularCollection.forEach(openFormular => {
            let formularClassName = "";
            let masterLinkToAttr = "";
            let formularCondition = "";
            let formularType = "";
            const openFormularSplit = openFormular.split(":");
            const formularClassNameSplit = openFormularSplit[0].split("#");

            if (formularClassNameSplit.length === 2) {
                formularClassName = formularClassNameSplit[0];
                formularType = formularClassNameSplit[1];
            } else
                formularClassName = openFormularSplit[0];

            switch (openFormularSplit.length) {
                case 1:
                    break;
                case 2:
                    masterLinkToAttr = openFormularSplit[1];
                    break;
                case 3:
                    masterLinkToAttr = openFormularSplit[1];
                    formularCondition = openFormularSplit[2];
                    break;
            }

            // Nějak nerozumím tomu, proč je ten push ve foreach cyklu... proč není mimo? Chcete mi snad říct, že jeden xml element reprezentující akci může obsahovat vlastně více akcí?!! Fuj!
            actions.push(new OpenForm(
                formularType,
                formularClassName,
                formularClassName, // IDK... reportName je oříšek
                masterLinkToAttr,
                formularCondition,
                actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
                actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
        });
    } else {
        actions.push(new SetAttribute(
            attrname,
            value,
            actionEl.getAttribute(CONST_SET_ATTRIBUTE_VALUE_TYPE) ?? "",
            actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
    }
};

/**
 * Funkce se stará o převedení xml do akce typu SendSMS. Blbá věc tu je ta, že se využívá magic attributu 'recipient',
 * který v závislosti na attributu 'recipientType' může obsahovat více logických hodnot oddělených středníkem.
 * Místo toho by bylo dobré, kdyby každá logická část měla svůj atribut.
 *
 * @param actionEl XML pro aktivitu.
 * @param actions Pole akcí, které se má appendovat.
 */
export const manageSendSmsXmlElement = (actionEl: Element, actions: Action[]) => {
    const recipientType = actionEl.getAttribute(CONST_SEND_SMS_RECIPIENT_TYPE_AT) ?? "";
    const recipient = actionEl.getAttribute(CONST_SEND_SMS_RECIPIENT_AT) ?? "";

    if (recipientType === SendSmsRecipientType.condition) {
        const data = recipient.split(";");
        const className = (data.length > 0) ? data[0] : "";
        const attrName = (data.length > 1) ? data[1] : "";
        const dataCondition = (data.length > 2) ? data[2] : "";

        actions.push(new SendSMS(
            "",
            className,
            attrName,
            dataCondition,
            actionEl.getAttribute(CONST_SEND_SMS_TEXT_AT) ?? "",
            recipientType,
            actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
    } else {
        actions.push(new SendSMS(
            recipient,
            "",
            "",
            "",
            actionEl.getAttribute(CONST_SEND_SMS_TEXT_AT) ?? "",
            recipientType,
            actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
    }
};

/**
 * Identická situace s akcí SendSMS... zase se používá magic attribut, který se skládá z více logických částí oddělených středníkem.
 * Určitě bude lepší, když se na serveru prostě jen přidají atributy, které maximálně budou prázdné, když pro daný typ adresáta nebudou potřeba...
 * Takhle si jen zbytečně vytváříme složitosti, které můžou způsobovat chyby.
 *
 * @param actionEl XML pro aktivitu.
 * @param actions Pole akcí, které se má appendovat.
 */
export const manageSendMailXmlElement = (actionEl: Element, actions: Action[]) => {
    const recipientType = actionEl.getAttribute(CONST_SEND_MAIL_RECIPIENT_TYPE_AT) ?? "";
    const recipient = actionEl.getAttribute(CONST_SEND_MAIL_RECIPIENT_AT) ?? "";

    if (recipientType === SendMessageRecipientType.condition) {
        const data = recipient.split(";");
        const className = (data.length > 0) ? data[0] : "";
        const attrName = (data.length > 1) ? data[1] : "";
        const dataCondition = (data.length > 2) ? data[2] : "";

        actions.push(new SendMail(
            recipientType,
            "",
            className,
            attrName,
            dataCondition,
            actionEl.getAttribute(CONST_SEND_MAIL_SUBJECT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_TEXT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_REPORT_TEMPLATE_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_SUMMARY_MAIL_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_FORMAT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_SEND_POSTPONE_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
    } else {
        actions.push(new SendMail(
            recipientType,
            recipient,
            actionEl.getAttribute("") ?? "",
            actionEl.getAttribute("") ?? "",
            actionEl.getAttribute("") ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_SUBJECT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_TEXT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_REPORT_TEMPLATE_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_SUMMARY_MAIL_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_FORMAT_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT) ?? "",
            actionEl.getAttribute(CONST_SEND_MAIL_SEND_POSTPONE_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_CONDITION_AT) ?? "",
            actionEl.getAttribute(CONST_ACTION_COMMENT_AT) ?? ""));
    }
};

/**
 * Pchjuu... tady je fakt všehochuť. Omnipotentní magic atributy, porušení logiky 1 instance == 1 akce
 * a na závěr maskování akce typem jiné akce (SetAttribute v tomto případě).
 * Toto je nejpřednější kandidát na refaktor na serveru. Snad největší svinstvo je to, že jedna tato akce obsahuje ve skutečnosti 'n' akcí.
 * Prosím nenechejme to takhle...
 *
 * @param xmlDoc workflow xml
 * @param actionsEl XML element, do kterého se přidávají jednotlivé akce
 * @param actions seznam akcí na aktivitě
 */
export const manageOpenFormAction = (documentNamespace: string, xmlDoc: Document, actionsEl: Element, actions: Action[]) => {
    const filteredOpenFormActions = actions.filter(action => action.constructor === OpenForm);
    const openFormActions: OpenForm[] = filteredOpenFormActions.map(action => action as OpenForm);

    if (!openFormActions.length)
        return;

    const firstOpenFormAction = openFormActions[0];
    const actionEl = xmlDoc.createElementNS(documentNamespace, CONST_SET_ATTRIBUTE_EL);

    firstOpenFormAction.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, firstOpenFormAction.condition);
    actionEl.setAttribute(CONST_ACTION_COMMENT_AT, firstOpenFormAction.comment);
    actionEl.setAttribute(CONST_SET_ATTRIBUTE_VALUE_TYPE, SetAttributeValueType.typedValue);
    actionEl.setAttribute(CONST_SET_ATTRIBUTE_ATTR_NAME_AT, "BLDialogFormName");

    let value = "";

    openFormActions.forEach(openForm => {
        value += getOpenFormValue(openForm) + ";";
    });

    value = value.replace(/;+$/g, ""); // trimne ';' na konci stringu

    const valueEl = xmlDoc.createElementNS(documentNamespace, CONST_SET_ATTRIBUTE_VALUE_EL); // konstanta pro SET ATTRIBUTE, protože se za to open form maskuje
    valueEl.innerHTML = escapeXmlString(value);
    valueEl.setAttribute("xsi:type", "xsd:string");
    actionEl.appendChild(valueEl);
    actionsEl.appendChild(actionEl);
};

/**
 * Pomocná metoda pro získání stringu, který se strká do atributu Value akce SetAttribute.
 * V podstatě tady zase tvoříme omnipotentní atribut, který se skládá z vícero logických celků
 * oddělených speciálními znaky.
 *
 * @param param0 instance OpenForm akce
 */
const getOpenFormValue = ({ masterLinkToAttr, formCondition, formType, formClass, reportName }: OpenForm): string => {
    const firstParam = formType === FormType.report ? reportName : formClass;

    return `${firstParam}#${formType}:${masterLinkToAttr}:${formCondition}`;
};
